import _ from 'lodash'
import Coordinates from 'coordinate-parser'

export default {
    parseCoordinates: function (str) {
        let normalized = _.chain(str).trim().replace(/,/g, '.');
        let pair = normalized.split(/[\s;]+/).map(Number).filter(_.isFinite).value();

        try {
            if (pair.length == 2) {
                // Простая пара чисел в МСК-23 или EPSG:4326
                return L.latLng(pair[0], pair[1]);
            } else {
                // Строка с градусами, минутами, секундами и прочее
                let coordinates = new Coordinates(normalized.value());
                return L.latLng([coordinates.getLatitude(), coordinates.getLongitude()]);
            }
        } catch (ex) {
            return null;
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/CoordinateUtils.js